<div class="provider-list-page">
  <header>
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-tab-group
          class="benefits-tabs"
          (selectedIndexChange)="onBenefitTabIndexChange($event)"
          [(selectedIndex)]="selectedBenefitTabIndex"
        >
          <mat-tab
            class="benefit-tab"
            [label]="benefit"
            *ngFor="let benefit of providerSearchParam.benefits"
          >
            <ng-template mat-tab-label>
              <mat-icon>folder</mat-icon>{{ benefit }}
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </mat-card-header>

      <mat-card-content>
        <div class="search-grid-container">
          <mat-form-field class="mat-form-field" appearance="outline">
            <mat-label>Province</mat-label>
            <mat-select
              (click)="onUserInteractChange()"
              [(value)]="selectedProvince"
              (selectionChange)="onProvinceSelected($event.value)"
            >
              <mat-option
                *ngFor="let province of filteredProvinces"
                [value]="province"
                >{{ province }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field" appearance="outline">
            <mat-label>Profession</mat-label>
            <mat-select
              (click)="onUserInteractChange()"
              [(value)]="selectedProfession"
              (selectionChange)="onProfessionSelected($event.value)"
              [disabled]="!hasMinimumSearchQueryParams"
            >
              <mat-option [value]="null">(All)</mat-option>
              <mat-option
                *ngFor="let profession of filteredProfessions"
                [value]="profession"
              >
                {{ profession }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            class="mat-form-field provider-name"
          >
            <mat-label>Name</mat-label>
            <input
              matInput
              [(ngModel)]="selectedName"
              (keydown.enter)="searchPaginatedProviders(false, true)"
              [disabled]="!hasMinimumSearchQueryParams"
            />
            <button
              *ngIf="selectedName"
              class="clear-name-icon-button"
              mat-icon-button
              matSuffix
              aria-label="Clear"
              (click)="clearName()"
            >
              <mat-icon class="small-icon">close</mat-icon>
            </button>
          </mat-form-field>
          <div class="show-concerns-toggle">
            <p>Concerns</p>
            <mat-slide-toggle
              [(ngModel)]="showConcernsOnly"
              [disabled]="!hasMinimumSearchQueryParams"
              [attr.aria-label]="
                showConcernsOnly
                  ? 'Disable concerns filter'
                  : 'Enable concerns filter'
              "
            >
              <span class="accessibility-aria-label-hidden">Concerns</span>
            </mat-slide-toggle>
          </div>
          <mat-card-actions class="search-actions">
            <button
              mat-button
              class="search-button"
              (click)="searchPaginatedProviders(true, true)"
              [disabled]="!hasMinimumSearchQueryParams"
            >
              Search
            </button>
            <button mat-button class="underlined-button" (click)="clear()">
              Clear search
            </button>
          </mat-card-actions>
        </div>
        <div class="paginator-container">
            <p><strong>Results:</strong></p>
            <mat-paginator
              #paginator
              [pageSizeOptions]="[20, 50, 100]"
              aria-label="Select page of providers"
              (page)="searchPaginatedProviders(false, true)"
              [disabled]="!selectedProvince || this.paginator.length == 0"
            ></mat-paginator>
          <button
            class="export-button"
            mat-icon-button
            color="accent"
            (click)="exportProviders()"
            [disabled]="matDataSource.data.length === 0"
            matTooltip="Export results"
            aria-label="Export results"
          >
            <mat-icon>download</mat-icon>
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </header>
  <main>
    <section
      class="results-list"
      [ngClass]="{
        expanded: !selectedProvider
      }"
    >
      <mat-form-field
        class="filter-field"
        appearance="outline"
        *ngIf="matDataSource.data.length > 0"
      >
        <input
          #input
          matInput
          (keyup)="applyFilter($event)"
          placeholder="Filter the results"
        />
      </mat-form-field>

      <div class="table-container">
        <!-- No Results -->
        <h2 class="message" *ngIf="matDataSource.data.length == 0 && !loading">
          {{ resultsMessage }}
        </h2>

        <!-- Results -->
        <table
          *ngIf="matDataSource.data.length > 0"
          mat-table
          [dataSource]="matDataSource"
          matSort
          class="results-table"
          tabindex="0"
          (keydown)="onKeydown($event)"
        >
          <ng-container matColumnDef="results">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Results list
            </th>
            <td
              mat-cell
              *matCellDef="let provider"
              [ngClass]="{
                'selected-row-indicator': provider?.id === selectedProvider?.id
              }"
            >
              <div class="details-row-box">
                <div
                  class="box"
                  [ngClass]="{
                    'extended-box': selectedProvider
                  }"
                >
                  <p
                    *ngIf="provider?.name"
                    [ngClass]="{
                      'selected-name': provider?.id === selectedProvider?.id
                    }"
                  >
                    <strong>{{ provider.name }}</strong>
                  </p>
                </div>

                <div class="box shortened" *ngIf="!selectedProvider">
                  <p>{{ getAddress(provider) }}</p>
                </div>

                <div class="box" *ngIf="!selectedProvider">
                  <div *ngIf="provider?.type">
                    <p>
                      Type:
                      {{ provider.type }}
                    </p>
                  </div>
                  <div class="inline" *ngIf="provider?.phone">
                    <mat-icon class="mat-icon-small">phone</mat-icon>
                    <p>
                      {{ provider.phone }}
                    </p>
                  </div>
                  <div class="inline" *ngIf="provider?.fax">
                    <mat-icon class="mat-icon-small">fax</mat-icon>
                    <p>
                      {{ provider.fax }}
                    </p>
                  </div>
                </div>

                <div class="box" *ngIf="!selectedProvider">
                  <p>
                    Concerns:
                    {{ provider.hasConcerns ? 'Yes' : 'No' }}
                  </p>
                  <p *ngIf="provider?.status">
                    Status:
                    {{ provider.status }}
                  </p>
                  <p *ngIf="provider?.staff?.length > 0">
                    Staff #:
                    {{ provider.staff?.length }}
                  </p>
                </div>

                <div class="box tr" *ngIf="selectedProvider">
                  <p class="mt-10">
                    Concerns:
                    {{ provider.hasConcerns ? 'Yes' : 'No' }}
                  </p>
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let provider; columns: displayedColumns; let i = index"
            (click)="openDetails(provider, i)"
            [id]="'row-' + provider.id"
          ></tr>
        </table>
      </div>
    </section>

    <mat-card
      appearance="outlined"
      class="details-container"
      *ngIf="selectedProvider"
    >
      <div class="details-title">
        <div class="title">
          <h3>
            {{ selectedProvider?.name }}
            <span *ngIf="formatUrl(selectedProvider?.url) as url">
              <a
                *ngIf="url"
                [href]="url"
                [matTooltip]="url"
                target="_blank"
                class="link-with-icon"
                rel="noopener"
                aria-label="Opens in a new tab"
              >
                <mat-icon class="mat-icon-small">open_in_new</mat-icon>
              </a>
            </span>
          </h3>
        </div>
        <button mat-icon-button aria-label="Close" (click)="onCloseDetails()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-card-content class="details-card-content">
        <provider-details-view
          [provider]="selectedProvider"
          [province]="selectedProvince"
        ></provider-details-view>
      </mat-card-content>
    </mat-card>
  </main>
</div>
